/* eslint complexity: ["error", 7] */
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import FormSelect from '@homeaway/react-form-select';
import './FlagDropdown.less';

class FlagDropdown extends Component {
    static propTypes = {
        id: PropTypes.string,
        countryCode: PropTypes.string,
        phoneCode: PropTypes.string,
        flagData: PropTypes.arrayOf(PropTypes.shape({
            cc: PropTypes.string,
            masks: PropTypes.array,
            name: PropTypes.string,
            phoneCode: PropTypes.string
        })),
        onChange: PropTypes.func
    }

    static defaultProps = {
        flagData: [],
        onChange: () => {},
    }

    constructor(props) {
        super(props);

        this.items = this.getSelectItems();
    }

    getSelectItems() {
        let items = [];
        this.props.flagData.map((data) => {
            items.push({
                value: data.cc,
                label: `${data.name} (+${data.phoneCode})`
            });
        });

        return items;
    }

    handleChangeEvent = (e) => {
        let countryData = this.props.flagData.filter((item) => {
            return e.target.value === item.cc;
        });

        this.props.onChange(e, countryData[0]);
    }

    render() {
        return (
            <>
                <FormSelect
                    className="InputTel__select"
                    name={this.props.id}
                    items={this.items}
                    label={this.props.labels.countryCode}
                    value={this.props.countryCode}
                    onChange={this.handleChangeEvent}
                />
                <span className="InputTel__phone-code">{`+${this.props.phoneCode}`}</span>
            </>
        );
    }
}

export default FlagDropdown;
